module.exports = __webpack_public_path__ + "img/flag-1.70c14f1e.svg";